/**
 * icons.js
 * Central Icon Registry for Lucide Icons.
 * Maps string identifiers from navigation.js to actual Lucide objects.
 */
import {
    createIcons,
    createElement, // Import createElement
    Home,
    BookOpen,
    FileText,
    Library,
    ShieldAlert,
    Palette,
    Megaphone,
    Shield,
    Share2,
    Siren,
    Settings,
    Search,
    Bell,
    Menu,
    X,
    ChevronRight,
    User,
    LogOut,
    Factory, // Added for Popup Factory
    Info, // Added for About
    Sparkles, // Added for Plaza
    TrendingUp, // Added for Admin Analytics
    Lightbulb, // Added for Wisdom of Stars
    Compass, // Added for Guide
    Star, // Added for Patronage/Custom
    Plus, // Added for Custom Menu Add
    Trash2, // Added for Custom Menu Delete
    MoreHorizontal, // Added for Custom Menu More
    Link, // Added for External Link Config
    BookHeart // Added for The Empty Shelf (Replaces Sparkles/AutoAwesome)
} from 'lucide';

export const IconMap = {
    Home,
    BookOpen,
    FileText,
    Library,
    ShieldAlert,
    Palette,
    Megaphone,
    Shield,
    Share2,
    Siren,
    Settings,
    Search,
    Bell,
    Menu,
    X,
    ChevronRight,
    User,
    LogOut,
    Factory,
    Info,
    Sparkles,
    TrendingUp,
    Lightbulb,
    Compass,
    Star,
    Plus,
    Trash2,
    MoreHorizontal,
    Link,
    AutoAwesome: BookHeart // Map AutoAwesome key to BookHeart Icon
};

/**
 * Renders an icon into a specific element.
 * @param {HTMLElement} element - Target element
 * @param {string} iconName - Key from IconMap (e.g. 'Home')
 * @param {object} attrs - Optional attributes (size, class, etc.)
 */
export const renderIcon = (element, iconName, attrs = {}) => {
    if (!IconMap[iconName]) {
        console.warn(`Icon not found: ${iconName}`);
        return;
    }

    // Clear element
    element.innerHTML = '';

    // Create SVG using Lucide's createElement
    // Note: Lucide 0.4+ uses createElement, older might use specific API.
    // Assuming standard package usage.
    const iconNode = createElement(IconMap[iconName]);

    // Apply attributes
    // createElement returns an SVGElement
    if (attrs.class) iconNode.setAttribute('class', attrs.class);
    if (attrs['stroke-width']) iconNode.setAttribute('stroke-width', attrs['stroke-width']);

    // Append
    element.appendChild(iconNode);
};

/**
 * Bulk render helper (Optional, usually not needed if we use renderIcon everywhere)
 */
export const refreshIcons = (root = document) => {
    // No-op or implementation if needed for static HTML
    // createIcons({ ... }) // Use if needed
};
